/* @flow weak */
import apiRequest from 'lib/apiRequest';
import File from 'entities/File';
import FileDropzoneMixinSupport from 'lib/FileDropzoneMixinSupport.js';
import _ from 'lodash';

const mixin = {
  uploadURL: null,

  getUploadURL() {
    return this.uploadURL;
  },

  // NOTE: file is a File web interface object
  // Its properties must be parsed individually (can't do new File(file))
  parseFile(file) {
    return new File({
      id: file.id,
      content_type: file.type,
      size: file.size,
      name: file.name,
      urls: file.urls,
    });
  },

  updateRemainingCharacters() {
    // Awful coupling to components using this mixin =(
    if (this.getRemainingCharacters) {
      const remainingCharactersCount = this.getRemainingCharacters(this.state.text);
      this.setState({ remainingCharactersCount });
    }
  },

  handleAddedFile(file) {
    file.key = _.uniqueId();

    this.state.fileData[file.key] = { type: file.type };
    this.state.fileEntities[file.key] = this.parseFile(file);

    this.setState({
      files: this.state.files.concat(file),
    }, this.updateRemainingCharacters);
  },

  handleRemovedFile(file) {
    const fileIndex = this.state.files.indexOf(file);
    this.state.files.splice(fileIndex, 1);
    delete this.state.fileData[file.key];
    delete this.state.fileEntities[file.key];

    this.setState({
      files: this.state.files,
      fileEntities: this.state.fileEntities,
      fileData: this.state.fileData,
    }, this.updateRemainingCharacters);
  },

  handleThumbnail(file, dataUrl) {
    this.state.fileData[file.key].thumbnail = dataUrl;
  },

  handleUploadProgress(file, progress /* , bytesSent */) {
    this.state.fileData[file.key].progress = progress;
    this.setState({ fileData: this.state.fileData });
  },

  handleAcceptFile(file, done) {
    const send = (img = {}) => {
      const request = apiRequest('/files', 'POST', {
        file: {
          name: file.name,
          height: img.height || 0,
          width: img.width || 0,
        },
      });
      request.then((response) => {
        this.uploadURL = response.upload_url;
        this.uploadFields = response.fields;
        file.id = response.id;
        this.state.fileEntities[file.key].set('id', response.id);
        done();
        this._getDropzone().processQueue();
      }, () => {
        this.handleUploadError(file);
        done('Unable to upload file');
      });
    };

    // Detect if the uploaded file is an image by attempting to load it as such.
    const fileReader = new FileReader(); // eslint-disable-line no-undef
    fileReader.onload = () => {
      const imgDataUri = fileReader.result;
      const img = document.createElement('img');
      img.onload = () => {
        send(img);
      };
      img.onerror = send;
      img.src = imgDataUri;
    };
    fileReader.readAsDataURL(file);
  },

  handleSendingFile(file, xhr, formData) {
    Object.keys(this.uploadFields).forEach((key) => {
      formData.append(key, this.uploadFields[key]);
    });
  },

  handleUploadSuccess(file) {
    const request = apiRequest(`/files/${file.id}/ack`, 'POST', {});
    request.then((response) => {
      this.state.fileEntities[file.key] = File.fromJSON(response);
      this.setState({
        uploadedFile: File.fromJSON(response),
        fileEntities: this.state.fileEntities,
      });
      if (this.onUploadSuccess) {
        this.onUploadSuccess(file);
      }
    }, () => this.handleUploadError(file));
  },

  handleUploadError(file, error) {
    // A second file is attempting to be uploaded
    if (this.state.files.length > 1) {
      this.removeFile(file);
      return;
    }

    console.warn('Upload Error', error);
    this.state.fileData[file.key].error = error;
    this.setState({ fileData: this.state.fileData });
    if (this.onUploadFailed) {
      this.onUploadFailed(this.state.fileEntities[file.key], error);
    }
  },

  handleFileFromId(fileId, message) {
    const request = apiRequest(`/files/${fileId}`, 'GET');
    request.then((response) => {
      message.setOnlyFile(response);
    }).catch(err => console.error('File retrieval failure', err));
    return request;
  },
};

const FileUploaderMixin = Object.assign(mixin, FileDropzoneMixinSupport);

export default FileUploaderMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/FileUploaderMixin.js